export default __webpack_public_path__ + "static/media/icon.a1ea0203.png";